"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tags = void 0;
/* eslint-disable max-len */

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var tags = function tags(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'tags-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.65685 5.51178C9.59278 5.51178 9.52993 5.5374 9.48251 5.58526L4.82565 10.2851C4.72478 10.3869 4.72478 10.5547 4.82565 10.6565L9.06829 14.9383C9.16538 15.0363 9.3199 15.0363 9.41699 14.9383L9.42263 14.9326L14.1762 10.2366C14.2227 10.1887 14.25 10.1228 14.25 10.0528V5.771C14.25 5.62133 14.1316 5.51178 14 5.51178H9.65685ZM8.41699 4.52948C8.74464 4.19881 9.19049 4.01178 9.65685 4.01178H14C14.973 4.01178 15.75 4.80592 15.75 5.771V10.0528C15.75 10.5171 15.5673 10.9638 15.2399 11.2943L15.2342 11.3L10.4793 15.9973C9.79508 16.6843 8.68568 16.6833 8.00278 15.9941L3.76013 11.7123C3.07996 11.0259 3.07996 9.91573 3.76013 9.22928L8.41699 4.52948Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M12.7782 8.29728C12.3877 8.68781 11.7545 8.68781 11.364 8.29728C10.9734 7.90676 10.9734 7.2736 11.364 6.88307C11.7545 6.49255 12.3877 6.49255 12.7782 6.88307C13.1687 7.2736 13.1687 7.90676 12.7782 8.29728Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M15.25 7.771C15.25 7.62133 15.1316 7.51178 15 7.51178V6.01178C15.973 6.01178 16.75 6.80592 16.75 7.771V12.0528C16.75 12.5171 16.5673 12.9638 16.2399 13.2943L16.2342 13.3L11.4793 17.9974C10.795 18.6843 9.68566 18.6833 9.00278 17.9941L4.76013 13.7123C4.07996 13.0259 4.07996 11.9157 4.76013 11.2293L5.82565 12.2851C5.72478 12.3869 5.72478 12.5547 5.82565 12.6565L10.0683 16.9383C10.1654 17.0363 10.3199 17.0363 10.417 16.9383L10.4226 16.9326L15.1762 12.2366C15.2227 12.1887 15.25 12.1228 15.25 12.0528V7.771Z',
    fill: '#4B5563'
  }));
};

exports.tags = tags;